
    import { Component, Vue } from 'vue-property-decorator';
    import { ApiRepository } from '@/api';
    import TableFilter from '@/components/table/Filters.vue';
    import Layout from '@/components/layout/Layout.vue';
    import TablePager from '@/components/table/Pager.vue';
    import Table from '@/components/table/Table.vue';

    @Component({
        components: {
            Layout,
            Table,
            TableFilter,
            TablePager
        },
        props: {
            keys: Object,
            links: Array,
            dates: Array,
            dateFormat: {
                type: String,
                default: () => { return 'DD.MM.YYYY'; }
            },
            selects: Object,
            customColumnClass: {
                type: Object,
                default: () => { return {}; }
            },
            relations: Array,
            // rows: Array,
            api: String,
            isexport: Boolean,
            appPart: String,
        },
    })
    export default class ApplicationIndex extends Vue {
        private filters = '';
        private storeFilters = {};
        private data = [];

        // paging
        private pager = {
            count: 0,
            take: 0,
            page: 0,
            totalCount: 0
        };

        // sorting
        private key = '';
        private sort = '';
        private showSpinner = true;

        public async mounted() {
              // // tabulka sa naplni bud zo statickych dat alebo z response api endpointu
              // if (this.$props.rows) {
              //   this.data = this.$props.rows;
              // } else {
              //   this.data = await ApiRepository[this.$props.api]();
              // }
            let params: any = {};
            if (this.$props.relations) {
                params['relations'] = this.$props.relations;
            }


            if (this.$props.appPart && this.$store.getters.appFilters) {
              if (this.$props.appPart === 'applications') {
                await this.setFiltersFromStore(this.$store.getters.appFilters)
              }
            } else {

              let response = await ApiRepository[this.$props.api](params);

              this.data = response.data;
              this.pager = {
                count: response.count,
                take: response.take,
                page: response.page,
                totalCount: response.totalCount
              };

            }

            this.showSpinner = false;
        }

        private async changePage(page: Number) {
            await this.changeOptions({
                key: this.key || 'id',
                page: page
            });
        }

        private async changeOptions(data: any) {
            this.pager.page = data.page || this.pager.page;
            this.key = data.key;
            this.sort = data.sort;

            await this.sendRequest({
                page: this.pager.page,
                sort: this.key,
                order: this.sort ? 'ASC' : 'DESC',
                filters: this.filters
            });
        }

        private async setFiltersFromStore(filters: any) {
          let storeFilters: any = {};
          filters.split(',').forEach((filter: string) => {
            let splFilter = filter.split(':');
            if (splFilter.length === 2) {
              storeFilters[splFilter[0]] = splFilter[1];
            }
          })
          await this.setFilter(storeFilters);
        }

        private async setFilter(filters: any) {
            let strFilter: any = [];

            if (filters) {
                Object.keys(filters).forEach((key: string) => {
                    strFilter.push(key + ':' + filters[key]);
                });
            }
            strFilter = strFilter.join(',');

            this.filters = strFilter;

            if (this.$props.appPart === 'applications') {
              this.$store.getters.appFilters = this.filters
            }

            await this.sendRequest({
                sort: this.key || 'id',
                order: this.sort ? 'ASC' : 'DESC',
                filters: strFilter
            });
        }

        private async sendRequest(params: object = {}) {
            this.showSpinner = true;

            if (this.$props.relations) {
                params = {
                    relations: this.$props.relations,
                    ...params
                };
            }

            let response = await ApiRepository[this.$props.api](params);

            if(response.data.length == 0){
                this.isexport = false;
            }

            this.data = response.data;
            this.pager = {
                count: response.count,
                take: response.take,
                page: response.page,
                totalCount: response.totalCount
            };

            this.showSpinner = false;
        }
        private isexport = true;
    }
